/* ============================================================
   YOLÈTE — Fiche produit (rendu depuis ?id=)
   Style épuré (inspiration Maje) : galerie, coloris, taille,
   ajout au panier, détails en accordéons. Peu de texte.
   ============================================================ */

const FINISH_LABELS = window.FINISH_LABELS || {
  dore: 'Doré', 'vieil-or': 'Vieil or', argent: 'Argenté', 'vieil-argent': 'Vieil argent',
};
const COLLECTION_LABELS = window.COLLECTION_LABELS || {
  intemporelle: 'Intemporelle', bijou: 'Bijou', western: 'Western', jungle: 'Animalier',
  glitter: 'Glitter', emaillee: 'Émaillée', statement: 'Statement', 'black-list': 'Black List',
};

const SIZE_ROWS = [
  ['75', '68 à 73', '34 à 36'], ['80', '73 à 78', '36 à 38'], ['85', '78 à 83', '38 à 40'],
  ['90', '83 à 88', '40 à 42'], ['95', '88 à 93', '42 à 44'], ['100', '93 à 98', '44 à 46'],
  ['105', '98 à 103', '46 à 48'], ['110', '103 à 108', '48 à 50'], ['115', '108 à 113', '50 à 52'],
];
const WAIST_SIZES = ['75', '80', '85', '90', '95', '100', '105', '110'];

/* Description HTML d'une fiche Shopify, rendue sans risque dans la fiche du
   site : titres en paragraphes, seuls gras, italique, liens et listes gardés,
   attributs retirés (styles collés depuis l'éditeur), paragraphes vides ôtés. */
function htmlPropre(html) {
  const t = document.createElement('template');
  t.innerHTML = String(html || '');
  const GARDE = { P: 1, BR: 1, STRONG: 1, B: 1, EM: 1, I: 1, A: 1, UL: 1, OL: 1, LI: 1 };
  const PARA = { H1: 1, H2: 1, H3: 1, H4: 1, H5: 1, H6: 1, DIV: 1 };
  (function nettoie(n) {
    Array.from(n.childNodes).forEach(c => {
      if (c.nodeType === 3) return;
      if (c.nodeType !== 1 || /^(META|SCRIPT|STYLE|IFRAME|OBJECT|EMBED|LINK)$/.test(c.tagName)) { c.remove(); return; }
      nettoie(c);
      if (PARA[c.tagName]) { const p = document.createElement('p'); while (c.firstChild) p.appendChild(c.firstChild); c.replaceWith(p); return; }
      if (!GARDE[c.tagName]) { c.replaceWith(...Array.from(c.childNodes)); return; }
      Array.from(c.attributes).forEach(a => { if (!(c.tagName === 'A' && a.name === 'href')) c.removeAttribute(a.name); });
      if (c.tagName === 'A') {
        if (!/^https?:\/\//i.test(c.getAttribute('href') || '')) { c.replaceWith(...Array.from(c.childNodes)); return; }
        c.setAttribute('target', '_blank'); c.setAttribute('rel', 'noopener');
      }
    });
  })(t.content);
  /* un paragraphe dans un paragraphe (titre contenant un bloc) devient deux paragraphes à plat */
  t.content.querySelectorAll('p p').forEach(p => p.replaceWith(...Array.from(p.childNodes)));
  t.content.querySelectorAll('p, li').forEach(p => { if (!p.textContent.replace(/\u00a0/g, ' ').trim()) p.remove(); });
  return t.innerHTML.replace(/(<br>\s*){2,}/g, '<br>').trim();
}

/* Textes communs des fiches (Contenu › Métaobjets › Textes des fiches produit), dans la langue
   affichée : Shopify donne la traduction (28/10/2026). {largeur}, {collection}, {franco} sont
   remplacés ; sans collection, la mention de la collection disparaît. Repli : les textes d'avant. */
function texteFiche(cle, defaut, vars) {
  const T = window.YOLETE_TEXTES || {};
  let s = (T[cle] != null && String(T[cle]).trim() !== '') ? String(T[cle]) : defaut;
  vars = vars || {};
  if ('collection' in vars && !vars.collection) s = s.replace(/\s*[,·–-]?\s*(collection\s+)?\{collection\}(\s+collection)?/gi, '');
  for (const k in vars) s = s.split('{' + k + '}').join(String(vars[k]));
  return s;
}
/* En anglais, une fiche dont la traduction manque ou n'est plus à jour (liste tenue chaque matin
   par scripts/traductions_fiches.py) : 'descriptions' ou 'details'. */
function aTraduire(quoi, handle) {
  if (window.YOLETE_LANG !== 'en') return false;
  const L = (window.SHOP && window.SHOP.traductionsAFaire) || {};
  return (L[quoi] || []).indexOf(handle) !== -1;
}
/* Texte saisi dans l'admin, mots entre **deux astérisques** en gras */
function gras(t) { return echappe(t).replace(/\*\*(.+?)\*\*/g, '<strong>$1</strong>'); }

/* Texte saisi dans l'admin, affiché tel quel (pas interprété comme du HTML) */
function echappe(t) {
  return String(t).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
}

function shortDescr(t) {
  if (!t) return '';
  var s = t.replace(/\s+/g, ' ').trim();
  if (s.length <= 150) return s;
  var cut = s.slice(0, 155); var dot = cut.lastIndexOf('. ');
  return dot > 70 ? cut.slice(0, dot + 1) : cut.slice(0, 145).trim() + '…';
}

/* Coloris (BOUCLE_SWATCHES) du design, même si l'id chargé n'est pas le représentant. */
function findWays(p) {
  /* Sans entrée dans boucles-photos.js : pastilles standard lues dans les variantes
     Shopify (common.js, swatchesShopify), cas d'une boucle ajoutée par Charlotte. */
  const shopify = () => ((typeof swatchesShopify === 'function' && swatchesShopify(p)) || {}).swatches || null;
  if (typeof BOUCLE_SWATCHES === 'undefined') return shopify();
  const prep = sw => (typeof avecPastillesShopify === 'function') ? avecPastillesShopify(p, sw) : sw;   /* pastilles choisies dans Shopify */
  if (BOUCLE_SWATCHES[p.id]) return prep(BOUCLE_SWATCHES[p.id].swatches || null);
  const baseFn = p.type === 'ceinture' ? window.ceintureBase : window.boucleBase;
  if (baseFn) {
    const bs = baseFn(p);
    for (const id in BOUCLE_SWATCHES) {
      const r = PRODUCTS.find(x => x.id === id);
      if (r && r.type === p.type && baseFn(r) === bs && (p.type === 'ceinture' || r.width === p.width))
        return prep(BOUCLE_SWATCHES[id].swatches || null);
    }
  }
  return shopify();
}

/* Cuir d'une tige -> clé des ceintures composer (couleurs + photos arrondies). */
function tigeLeatherKey(p) {
  if (p.leather) return p.leather;   /* posé par tiges-catalog.js, le nom vient de Shopify */
  var n = (p.name || '').replace(/^Tige\s+/i, '').toLowerCase();
  if (/vintage\s*l[ée]opard/.test(n)) return 'vintage-leo';
  if (/vintage/.test(n)) return 'vintage';
  if (/python/.test(n)) return 'python';
  if (/preto/.test(n)) return 'preto';
  return null;
}

/* Sur le thème Shopify, /products/<handle> rend cette page : le handle arrive
   par window.YOLETE_ROUTE (template product.liquid) au lieu de ?id=. */
const pid = new URLSearchParams(location.search).get('id')
  || (window.YOLETE_ROUTE && YOLETE_ROUTE.kind === 'product' ? YOLETE_ROUTE.handle : null);
let product = PRODUCTS.find(p => p.id === pid);

/* Adresse native d'une ceinture (/products/<handle Shopify>), celle que Meta et
   Google Shopping envoient : la tige n'existe sur le site que sous ses fiches
   par coloris (tiges-catalog.js). On affiche la famille, premier coloris. */
if (!product && window.YOLETE_ROUTE && YOLETE_ROUTE.kind === 'product') {
  /* Fiche Shopify -> [cuir, largeur], lu dans la table de tiges-catalog.js (cuirs ajoutés par Charlotte compris) */
  const TIGE_NATIVE = { '19840pr-copie': ['preto', 40], 'preto': ['preto', 25], 'python-1': ['python', 40], 'python': ['python', 25],
                        'vintage': ['vintage', 40], 'vintage-25': ['vintage', 25], 'vintage-leopard': ['vintage-leo', 40] };
  Object.keys(window.TIGE_HANDLE || {}).forEach(c => Object.keys(window.TIGE_HANDLE[c]).forEach(w => { TIGE_NATIVE[window.TIGE_HANDLE[c][w]] = [c, +w]; }));
  const t = TIGE_NATIVE[YOLETE_ROUTE.handle];
  if (t) product = PRODUCTS.find(p => p.type === 'tige' && p.width === t[1] && tigeLeatherKey(p) === t[0]) || null;
}
const root = document.getElementById('productRoot');

/* Garde-fou : une boucle hors de la sélection du dossier client n'est pas vendue.
   Elle ne doit donc pas avoir de fiche accessible, même par lien direct — sinon
   on peut atterrir sur un produit absent de la boutique (cas de la N214). */
if (product && product.type === 'boucle'
    && typeof inFolderBoucle === 'function' && !inFolderBoucle(product)) {
  product = null;
}

/* ---------- Indexation ----------
   Deux situations que Google traitait mal :
   1. /pages/produit SANS identifiant affiche « Produit introuvable » en
      répondant 200 : c'est un soft 404. On le marque noindex.
   2. /pages/produit?id=<handle> rend la même page que /products/<handle>,
      qui porte le bon titre. On pointe la canonique vers elle pour que
      Google n'indexe qu'une seule adresse par produit. */
(function indexation() {
  function meta(nom, valeur) {
    var m = document.querySelector('meta[name="' + nom + '"]');
    if (!m) { m = document.createElement('meta'); m.name = nom; document.head.appendChild(m); }
    m.content = valeur;
  }
  var surGabarit = /\/pages\/produit$|produit\.html$/.test(location.pathname);
  if (!product) {
    if (surGabarit || !pid) meta('robots', 'noindex, follow');
    return;
  }
  if (!window.Shopify || !window.SHOP) return;
  var connu = ['boucles40', 'boucles25', 'tiges40', 'tiges25', 'extra', 'sacs'].some(function (k) {
    return (SHOP[k] || []).some(function (x) { return x.handle === product.id; });
  });
  if (!connu) return;                       /* tige du composeur : pas de page native */
  if (location.pathname.indexOf('/products/') === 0) return;   /* deja la bonne adresse */
  /* Mémorisé ici, appliqué par setSEO : celui-ci s'exécute après et réécrirait
     la balise avec l'adresse courante. */
  window.YOLETE_CANONIQUE = location.origin + '/products/' + product.id;
})();

/* Carte cadeau (2 nov 2026) : absente du catalogue du site, elle affichait « Produit
   introuvable » alors qu'elle se vend. Sa fiche se construit avec ses montants, lus dans
   ses variantes Shopify (templates/product.liquid, YOLETE_FICHE.carteCadeau). */
function ficheCarteCadeau(C) {
  const vs = (C.variantes || []).filter(v => v.prix > 0);
  let sel = Math.max(0, vs.findIndex(v => v.dispo));
  const imgs = C.images || [];
  const F = window.YOLETE_FICHE || {};
  const descr = F.descrHtml ? htmlPropre(F.descrHtml) : '';
  const prix = v => euro(v.prix).replace(',00', '');
  root.innerHTML = `
    <section class="wrap pd">
      <div class="gallery">
        <div class="gallery-main"><img id="mainImg" src="${imgs[0] || ''}" alt="${echappe(C.titre)}" /></div>
        ${imgs.length > 1 ? `<div class="gallery-thumbs" id="thumbs">${imgs.map((src, i) => `<button class="thumb${i === 0 ? ' active' : ''}" data-img="${src}"><img src="${src}" alt="${echappe(C.titre)} ${i + 1}" loading="lazy" /></button>`).join('')}</div>` : ''}
      </div>
      <div class="pd-info">
        ${C.libelle ? `<p class="pd-kind">${echappe(C.libelle)}</p>` : ''}
        <h1 class="pd-title">${echappe(C.titre)}</h1>
        <div class="pd-price" id="pdPrice">${prix(vs[sel])}</div>
        <div class="pd-select">
          <div class="pd-label">Montant</div>
          <div class="pd-chips" id="montantChips">${vs.map((v, i) => `<button class="pd-chip${i === sel ? ' active' : ''}" data-i="${i}"${v.dispo ? '' : ' disabled'}>${prix(v)}</button>`).join('')}</div>
        </div>
        <button class="btn btn-dark pd-add" id="addProduct">Ajouter au panier</button>
        ${descr ? `<div class="pd-acc"><details class="pd-acc-item" open><summary>Description</summary><div class="pd-acc-body pd-desc-shopify">${descr}</div></details></div>` : ''}
      </div>
    </section>`;
  const chips = document.getElementById('montantChips');
  chips.addEventListener('click', e => {
    const b = e.target.closest('.pd-chip'); if (!b || b.disabled) return;
    sel = +b.dataset.i;
    chips.querySelectorAll('.pd-chip').forEach(x => x.classList.toggle('active', x === b));
    document.getElementById('pdPrice').textContent = prix(vs[sel]);
  });
  const thumbs = document.getElementById('thumbs');
  if (thumbs) thumbs.addEventListener('click', e => {
    const t = e.target.closest('.thumb'); if (!t) return;
    document.getElementById('mainImg').src = t.dataset.img;
    thumbs.querySelectorAll('.thumb').forEach(x => x.classList.toggle('active', x === t));
  });
  document.getElementById('addProduct').addEventListener('click', () => {
    if (typeof window.ajouterVariante === 'function') window.ajouterVariante(vs[sel].id, C.titre + ' · ' + prix(vs[sel]));
  });
}
const CARTE = !product && window.YOLETE_FICHE && window.YOLETE_FICHE.carteCadeau;

if (CARTE && (CARTE.variantes || []).length) {
  ficheCarteCadeau(CARTE);
} else if (!product) {
  root.innerHTML = `
    <div class="wrap article-missing">
      <h1 class="section-title">Produit introuvable</h1>
      <p>Ce produit n'existe pas ou a été retiré.</p>
      <a href="/pages/produits" class="btn btn-dark">Retour à la boutique</a>
    </div>`;
} else {
  /* Référencement : titre, description et données structurées avec le mot que cherchent les clientes */
  (function seoProduit() {
    /* Fiche /products/ : titre, description et données structurées déjà écrits par Shopify
       (templates/product.liquid, 2 nov 2026), à partir des champs Référencement de l'admin. */
    if (window.YOLETE_FICHE && window.YOLETE_FICHE.seo) return;
    const w = product.width ? ` ${product.width} mm` : '';
    const EN = window.YOLETE_LANG === 'en';
    const ref = (product.type === 'tige' && product.familyName)
      ? (product.familyName + (product.colorLabel ? ' ' + product.colorLabel : ''))
      : String(product.name || '').replace(/^(BOUCLE|BUCKLE|LOOP)\s+/i, '').replace(/^TIGE\s+/i, '').replace(/\s*\d+\s*mm$/i, '').trim();
    const nice = ref.toLowerCase().replace(/(^|\s|-)\S/g, c => c.toUpperCase());
    const titre = EN
      ? (product.type === 'boucle' ? `${ref} belt buckle${w}` : product.type === 'tige' ? `${nice} leather belt${w}` : `${nice}`)
      : (product.type === 'boucle' ? `Boucle de ceinture ${ref}${w}` : product.type === 'tige' ? `Ceinture cuir ${nice}${w}` : `${nice}`);
    const descr = aTraduire('descriptions', product.shopHandle || product.id) ? '' : String(product.descr || product.description || '').replace(/<[^>]+>/g, ' ').replace(/^\s*BOUCLE INTERCHANGEABLE\s*/i, '').replace(/([a-z])([A-Z])/g, '$1. $2').replace(/\s+/g, ' ').trim();
    const phrase = EN
      ? (product.type === 'boucle'
          ? `${titre}, interchangeable jewellery buckle for Yolète leather belts, crafted like a piece of jewellery. Fits every Yolète strap in ${product.width} mm.`
          : product.type === 'tige' ? `${titre}, leather belt with interchangeable buckle, handcrafted in the Cantal, France.` : `${titre} by Yolète.`)
      : (product.type === 'boucle'
          ? `${titre}, boucle bijou interchangeable pour ceinture en cuir Yolète. ${descr}`
          : product.type === 'tige' ? `${titre}, ceinture en cuir à boucle interchangeable, façonnée à la main dans le Cantal. ${descr}` : `${titre} Yolète. ${descr}`);
    if (typeof setSEO === 'function') setSEO(`${titre} · Yolète`, phrase.slice(0, 158), window.YOLETE_CANONIQUE); else document.title = `${titre} · Yolète`;
    const img = product.img ? (String(product.img).startsWith('http') || String(product.img).startsWith('//') ? product.img : location.origin + '/' + product.img) : undefined;
    const ld = [{
      '@context': 'https://schema.org', '@type': 'Product', name: titre, sku: product.id, brand: { '@type': 'Brand', name: 'Yolète' },
      image: img, description: phrase.slice(0, 300), category: product.type === 'boucle' ? (EN ? 'Belt buckle' : 'Boucle de ceinture') : (EN ? 'Leather belt' : 'Ceinture en cuir'),
      offers: { '@type': 'Offer', priceCurrency: 'EUR', price: Number(product.price || 0).toFixed(2), availability: product.available === false ? 'https://schema.org/OutOfStock' : 'https://schema.org/InStock', url: location.href, itemCondition: 'https://schema.org/NewCondition', seller: { '@type': 'Organization', name: 'Yolète' } }
    }, {
      '@context': 'https://schema.org', '@type': 'BreadcrumbList', itemListElement: [
        { '@type': 'ListItem', position: 1, name: 'Accueil', item: location.origin + '/' },
        { '@type': 'ListItem', position: 2, name: product.type === 'boucle' ? 'Boucles de ceinture' : 'Ceintures en cuir', item: location.origin + (window.Shopify ? '/pages/produits' : '//pages/produits') + '?type=' + product.type },
        { '@type': 'ListItem', position: 3, name: titre, item: location.href }]
    }];
    const s = document.createElement('script'); s.type = 'application/ld+json'; s.textContent = JSON.stringify(ld); document.head.appendChild(s);
  })();

  const isBoucle = product.type === 'boucle';
  const isTige = product.type === 'tige';
  /* Maroquinerie : sacs et anses partagent la même fiche, mêmes blocs, mêmes
     informations. C'est le sens de « à la même enseigne » : une anse n'est pas
     un accessoire de second rang, c'est une pièce du catalogue. */
  const isMaroq = product.type === 'sac' || product.type === 'anse';
  /* Une pièce en précommande (champ precommande de la fiche Shopify) se
     « précommande », elle ne s'ajoute pas comme une pièce en stock. */
  const libelleAjout = product.precommande ? 'Précommander' : 'Ajouter au panier';
  const waysRaw = findWays(product);
  let ways = (waysRaw && waysRaw.length) ? waysRaw : null;

  /* Tige : coloris = les fiches du même cuir et de la même largeur, lues dans
     Shopify par tiges-catalog.js (2 oct 2026). La page s'ouvre sur le coloris
     de son adresse, et c'est le coloris CHOISI qui part au panier : avant, la
     pastille changeait la photo mais le panier recevait le coloris de l'adresse. */
  let tigePids = null;
  if (!ways && isTige) {
    const cuir = tigeLeatherKey(product);
    const ordre = x => (x.colorOrder != null ? x.colorOrder : 50);
    const sibs = PRODUCTS.filter(x => x.type === 'tige' && x.width === product.width && tigeLeatherKey(x) === cuir)
                         .sort((a, b) => ordre(a) - ordre(b));
    if (sibs.length) {
      ways = sibs.map(x => ({ label: x.colorLabel || x.name.replace(/^Tige\s+/i, ''), photo: x.photo || x.img, img: x.photo || x.img,
                              dotimg: x.dot || x.photo || x.img, dot: x.dot ? null : (x.dotColor || null), sid: x.id, price: x.price }));
      tigePids = sibs.map(x => x.id);
    }
  }

  /* Boucle : largeurs disponibles (25 / 40) si le même modèle existe dans les deux. */
  let widthSibs = null;
  if (isBoucle && typeof boucleBase === 'function') {
    const base = boucleBase(product);
    const byW = {};
    PRODUCTS.forEach(x => {
      if (x.type === 'boucle' && boucleBase(x) === base &&
          (typeof inFolderBoucle !== 'function' || inFolderBoucle(x))) byW[x.width] = x.id;
    });
    if (Object.keys(byW).length > 1) widthSibs = byW;
  }

  let imgs = ways ? ways.map(c => c.photo || c.img) : (product.images && product.images.length ? product.images : [product.img]);
  /* Tige à coloris : on garde en dernière vignette la photo des cuirs à la suite (les 3 ceintures). */
  /* Pour un cuir permanent, product.img est le détourage du MÊME coloris que la
     photo déjà présente : l'ajouter ferait deux vignettes identiques (signalé le
     13/09 sur Vintage Havane). Une vignette par coloris, rien de plus. */
  /* Une même photo ne doit apparaître qu'UNE fois en vignette : certains coloris
     partagent le même visuel (Suède), sinon on afficherait 6 vignettes identiques. */
  /* Boucle lue dans Shopify : les autres photos de la fiche (portée, détail) suivent celles des finitions. */
  if (ways && ways.length && ways[0].deShopify) imgs = imgs.concat(product.images || []);
  imgs = imgs.filter((src, i) => imgs.indexOf(src) === i);
  let sel = tigePids ? Math.max(0, tigePids.indexOf(pid)) : 0;
  let selColor = sel;

  /* Passant : champs Passant · largeur et hauteur (mm) de la fiche Shopify (21/10/2026),
     la table du fichier maison ne sert qu'à la copie de travail. */
  const passant = window.SHOP ? (product.passantShopify || null)
    : (typeof MAISON_PASSANT !== 'undefined' && typeof boucleBase === 'function')
      ? MAISON_PASSANT[(boucleBase(product) || '').toUpperCase() + '|' + product.width] : null;
  const collLabels = (product.collections || []).map(c => COLLECTION_LABELS[c] || c);
  if (typeof window.recalculerFinitions === 'function') window.recalculerFinitions();
  const finLabels = (product.finishes || []).map(f => FINISH_LABELS[f] || f);
  /* Libellé au-dessus du titre : Textes des fiches produit (28/10/2026) */
  const kindLabel = isBoucle ? texteFiche('libelleBoucle', 'Boucle bijou')
    : isTige ? texteFiche('libelleCeinture', TYPE_LABEL.tige || 'Tige')
    : product.type === 'sac' ? texteFiche('libelleSac', TYPE_LABEL.sac || 'Sac')
    : product.type === 'anse' ? texteFiche('libelleAnse', TYPE_LABEL.anse || 'Anse')
    : TYPE_LABEL[product.type];
  const eyebrow = isMaroq
    ? (product.eyebrow ? kindLabel + ' · ' + product.eyebrow : kindLabel)
    : kindLabel + (isBoucle
      ? (collLabels[0] ? ' · ' + collLabels[0] : '')
      : (product.style ? ' · ' + product.style : ''));

  /* --- Sélecteur de coloris --- */
  const legacyColors = product.colors || [];
  const colorName0 = ways ? (ways[sel] && ways[sel].label) : (legacyColors[0] && legacyColors[0].name);
  let colorBlock = '';
  const dots = (ways && isBoucle && typeof boucleDotSet === 'function')
    ? boucleDotSet(ways) : (ways || []).map(() => null);
  if (ways && ways.length > 1) {
    colorBlock = `<div class="pd-select">
      <div class="pd-label">Coloris <span class="pd-label-val" id="colorName">${colorName0 || ''}</span></div>
      <div class="swatches" id="swatches">
        ${ways.map((c, i) => {
          /* Boucle : pastille de matière. Tige : zoom photo du cuir (on voit le grain),
             sauf si le coloris n'a pas de photo dédiée -> teinte à plat (Suède). */
          const flat = c.dot || dots[i];
          const style = flat ? `background:${flat}` : `background-image:url(${c.dotimg || c.img})`;
          return `<button class="csw${i === sel ? ' active' : ''}${flat ? ' csw-mat' : ''}" data-idx="${i}" title="${c.label || 'Coloris'}" aria-label="${c.label || 'Coloris'}" style="${style}"></button>`;
        }).join('')}
      </div></div>`;
  } else if (!ways && legacyColors.length > 1) {
    colorBlock = `<div class="pd-select">
      <div class="pd-label">Couleur <span class="pd-label-val" id="colorName">${legacyColors[0].name}</span></div>
      <div class="swatches" id="swatches">
        ${legacyColors.map((c, i) => {
          /* Une photo de sac réduite à 22 px ne montre rien : quand le catalogue
             fournit la teinte du cuir, on l'affiche à plat. */
          const flat = c.dot || null;
          /* Une photo ne désigne un coloris que si elle lui est propre. Les sacs
             n'ont qu'une photo pour trois cuirs : choisir un cuir ne doit pas
             changer la photo, et cliquer cette vignette ne doit pas déplacer la
             pastille (signalé le 18 sept 2026). */
          const propre = !!c.img && legacyColors.filter(x => x.img === c.img).length === 1;
          return `<button class="csw${i === 0 ? ' active' : ''}${flat ? ' csw-mat' : ''}" data-name="${c.name}" ${propre ? `data-img="${c.img}"` : ''} title="${c.name}"${flat ? ` style="background:${flat}"` : ''}>${!flat && c.img ? `<img src="${c.img}" alt="${c.name}" loading="lazy" />` : ''}</button>`;
        }).join('')}
      </div></div>`;
  }

  /* Valeurs de l'option « Anse » des variantes Shopify (sacs en ligne) */
  const ansesShop = isMaroq ? [...new Set((product.variants || []).map(v => v.option2).filter(Boolean))] : [];

  /* --- Sélecteur de taille --- */
  let sizeBlock = '';
  /* Tailles d'une tige : celles de l'option Taille de sa fiche Shopify (28/10/2026), une
     taille ajoutée dans l'admin apparaît sur la fiche ; sans fiche Shopify, la grille habituelle. */
  const taillesFiche = (product.tailles && Object.keys(product.tailles).length)
    ? Object.keys(product.tailles).sort((a, b) => a - b) : WAIST_SIZES;
  if (isTige) {
    sizeBlock = `<div class="pd-select">
      <div class="pd-label">Taille <button class="pd-guide" id="sizeGuideBtn">${echappe(texteFiche('guideTitre', 'Guide des tailles'))}</button></div>
      <div class="pd-chips" id="sizeChips">${taillesFiche.map(s => `<button class="pd-chip" data-size="${s}">${s}</button>`).join('')}</div>
    </div>`;
  } else if (isMaroq && (ansesShop.length > 1 || (product.prixBook && product.prixBook.long))) {
    /* ALINA et ANGELE se choisissent avec l'anse courte ou l'anse longue, sans
       largeur (demande de la maison, 28 sept 2026, remplace « Anse courte 25 mm »
       du 25 et « Bella 40 / Bella 25 » du 18). Depuis le lancement du
       25 sept, les pastilles viennent des variantes Shopify (option « Anse »)
       et pilotent le prix et la variante mise au panier. Avant la mise en
       ligne, la fiche garde les deux libellés du book, à titre indicatif. */
    const anses = ansesShop.length > 1 ? ansesShop : ['Anse courte amovible', 'Anse longue amovible'];
    sizeBlock = `<div class="pd-select">
      <div class="pd-label">Anse</div>
      <div class="pd-chips" id="anseChips">
        ${anses.map((a, i) => `<button class="pd-chip${i === 0 ? ' active' : ''}" data-anse="${a}">${a}</button>`).join('')}
      </div>
    </div>`;
  } else if (isBoucle && widthSibs) {
    sizeBlock = `<div class="pd-select">
      <div class="pd-label">Largeur</div>
      <div class="pd-chips">${[25, 40].filter(w => widthSibs[w]).map(w =>
        `<a class="pd-chip${w === product.width ? ' active' : ''}" href="${productHref(widthSibs[w])}">${w} mm</a>`).join('')}</div>
    </div>`;
  }

  /* Sac : la description de la fiche Shopify, telle que Charlotte l'écrit (texte
     avant la liste « DETAILS »), sinon le champ Détail (28 sept 2026). */
  const shortD = isMaroq ? (product.descrIntro || product.detail || shortDescr(product.descr || '')) : '';
  /* Boucle et tige : la description de la fiche Shopify, en entier et dans la langue affichée
     (28/10/2026). En anglais, Shopify donne la traduction faite dans Paramètres › Langues. Avant,
     la boucle n'en montrait que la première phrase (N329 coupée) et l'anglais une phrase générique.
     Pour la boucle, le gabarit product.liquid donne la description de la fiche ouverte
     (YOLETE_FICHE) sans alourdir le catalogue ; sinon, le texte du catalogue, en entier.
     Sans description, ou en anglais sans traduction à jour (liste tenue chaque matin par
     scripts/traductions_fiches.py), la description par défaut des Textes des fiches produit. */
  const handleShopify = product.shopHandle || product.id;
  const ficheOuverte = (window.YOLETE_FICHE && window.YOLETE_FICHE.handle === product.id) ? window.YOLETE_FICHE : null;
  const sourceDesc = aTraduire('descriptions', handleShopify) ? ''
    : isBoucle ? ((ficheOuverte && ficheOuverte.descrHtml) || '')
    : isTige ? (product.descrHtml || '') : '';
  const texteDesc = sourceDesc || (isMaroq ? '' : String(product.descr || '').split(/\n+/).map(t => t.trim()).filter(Boolean).map(t => `<p>${t}</p>`).join(''));
  const descDefaut = isBoucle
    ? texteFiche('descriptionBoucle', "Boucle bijou interchangeable, façonnée comme un bijou. Elle s'adapte sur toutes les tiges Yolète en {largeur} mm et se retire d'un geste.", { largeur: product.width })
    : isTige ? texteFiche('descriptionCeinture', "Tige en cuir pleine fleur, tannage végétal, fabriquée en France. La boucle se retire d'un geste : changez-la aussi souvent que vous le souhaitez.")
    : '';
  const descHtml = isMaroq ? '' : (aTraduire('descriptions', handleShopify) || !htmlPropre(texteDesc).trim())
    ? (descDefaut ? `<p>${echappe(descDefaut)}</p>` : '') : htmlPropre(texteDesc);
  /* Bloc Détails : les lignes du champ « Details » de la fiche Shopify (une ligne, une puce),
     avec ce que donnent les autres champs de la fiche (28/10/2026) : pour une boucle, dimensions
     et passant après la première ligne, finitions à la fin ; pour un sac, la liste DETAILS de sa
     description ou les champs Maroquinerie. Champ vide (ou, en anglais, sans traduction à jour) :
     les Détails par défaut des Textes des fiches produit. Une ligne qui commence par
     « Dimensions », « Passant » ou « Finition » remplace la ligne calculée du même nom. */
  const lignes = t => String(t || '').split(/\r?\n/).map(x => x.replace(/^\s*[-•·*]\s*/, '').trim()).filter(Boolean);
  const detailsFiche = aTraduire('details', handleShopify) ? [] : lignes(product.details);
  const dejaDit = mot => detailsFiche.some(t => t.toLowerCase().startsWith(mot));
  const cm = v => (v / 10).toString().replace('.', ',');
  const collAffichee = collLabels[0] ? ((window.YOLETE_LANG === 'en' && window.I18N_EN && window.I18N_EN[collLabels[0]]) || collLabels[0]) : '';
  const lignesFiche = detailsFiche.length ? detailsFiche.map(echappe)
    : isBoucle ? lignes(texteFiche('detailsBoucle', 'Boucle bijou interchangeable, collection {collection}\nCompatible avec toutes les tiges Yolète en {largeur} mm',
                                   { collection: collAffichee, largeur: product.width })).map(echappe)
    : isTige ? lignes(texteFiche('detailsCeinture', "Largeur {largeur} mm · boucle interchangeable à l'infini", { largeur: product.width })).map(echappe)
    : [];
  const detailsMilieu = isBoucle ? [
    product.mm && !dejaDit('dimensions') ? `Dimensions ${cm(product.mm[0])} × ${cm(product.mm[1])} cm au plus large` : '',
    passant && !dejaDit('passant') ? `Passant ${cm(passant[0])} × ${cm(passant[1])} cm` : ''] : [];
  const detailsFin = isMaroq
    ? ((product.detailsListe || []).length
      /* la liste « DETAILS » de la description Shopify, telle quelle */
      ? product.detailsListe
      : [product.cuir, product.dims ? 'Dimensions ' + product.dims : '', product.fermeture, product.anse,
         product.rivets, product.doublure, product.compat].map(t => t ? echappe(t) : ''))
    : isBoucle ? [finLabels.length && !dejaDit('finition') ? `Finition ${finLabels.join(', ').toLowerCase()}` : ''] : [];
  const lignesDetails = lignesFiche.slice(0, 1).concat(detailsMilieu.filter(Boolean), lignesFiche.slice(1), detailsFin.filter(Boolean));
  const livraison = texteFiche('livraison', 'Livraison offerte dès {franco} €. Retours sous 14 jours.', { franco: +window.YOLETE_FRANCO || 99 });
  /* Guide des tailles des tiges : Textes des fiches produit, une ligne par taille, cases séparées par | */
  const guideTitre = texteFiche('guideTitre', 'Guide des tailles');
  const guideColonnes = texteFiche('guideColonnes', 'Taille | Tour de taille (cm) | Équiv. vêtement').split('|').map(t => t.trim());
  const guideLignes = texteFiche('guideLignes', SIZE_ROWS.map(r => r.join(' | ')).join('\n')).split(/\r?\n/)
    .map(l => l.trim()).filter(Boolean).map(l => l.split('|').map(t => t.trim()));
  /* Lien vers le composeur : il emmène LA pièce qu'on regarde, dans son coloris
     et, pour une tige, dans la taille déjà choisie (demande de Nathan, 20 sept
     2026). Avant, une tige arrivait sur le composeur vide. Recalculé à chaque
     changement de coloris ou de taille. */
  const lienComposeur = () => {
    const params = [];
    if (isBoucle) params.push('boucle=' + encodeURIComponent(product.id));
    else if (isTige) {
      const s = (ways && ways[selColor] && ways[selColor].sid) || (tigePids && tigePids[selColor]) || product.id;
      if (s) params.push('tige=' + encodeURIComponent(String(s).replace(/^tige-/, '')));
      const chip = document.querySelector('#sizeChips .pd-chip.active');
      if (chip && chip.dataset.size) params.push('t=' + chip.dataset.size);
    }
    params.push('w=' + (product.width === 25 ? 25 : 40));
    return '/pages/personnalisation?' + params.join('&');
  };
  const compoLink = lienComposeur();
  function majLienComposeur() { const a = document.getElementById('compoLink'); if (a) a.setAttribute('href', lienComposeur()); }

  /* Avis clients (Judge.me) : bloc écrit par Shopify dans la page, gardé et replacé sous la fiche */
  const avisServeur = document.getElementById('pdAvis');
  if (avisServeur) avisServeur.remove();
  const FICHE = window.YOLETE_FICHE || {};
  const badgeAvis = FICHE.id ? `<div class="jdgm-widget jdgm-preview-badge pd-avis-badge" data-id="${FICHE.id}">${FICHE.badge || ''}</div>` : '';

  root.innerHTML = `
    <section class="wrap pd">
      <div class="gallery">
        <div class="gallery-main"><img id="mainImg" src="${imgs[sel] || imgs[0]}" alt="${product.name}" />${typeof bandeauNouveaute === 'function' ? bandeauNouveaute(product) : ''}</div>
        ${imgs.length > 1 ? `<div class="gallery-thumbs" id="thumbs">
          ${imgs.map((src, i) => `<button class="thumb${i === sel ? ' active' : ''}" data-img="${src}" data-idx="${i}"><img src="${src}" alt="${product.name} ${i + 1}" loading="lazy" /></button>`).join('')}
        </div>` : ''}
      </div>

      <div class="pd-info">
        <nav class="crumb"><a href="${isMaroq ? '/pages/produits?type=sac,anse' : '/pages/produits?type=' + product.type}">${isMaroq ? 'Maroquinerie' : TYPE_LABEL[product.type] + 's'}</a> <span>·</span> <span>${product.name}</span></nav>
        <p class="pd-kind">${eyebrow}</p>
        <h1 class="pd-title">${product.name}</h1>
        ${badgeAvis}
        <div class="pd-price" id="pdPrice">${product.price > 0 ? euro(product.price) : '<span class="card-price-soon">Bientôt</span>'}</div>
        ${product.precommande && product.price > 0 && product.available !== false ? `<p class="pd-precommande">${product.precommande}</p>` : ''}

        ${colorBlock}
        ${sizeBlock}

        ${(function () {
          /* Trois états, trois mots. Une pièce pas encore sortie n'est pas
             « épuisée », et on propose de prévenir plutôt que de laisser un
             bouton mort. */
          const pasSortie = product.bientot === true || !(product.price > 0);
          const epuise = !pasSortie && product.available === false;
          const libelle = pasSortie ? 'Bientôt disponible' : epuise ? 'Épuisé' : libelleAjout;
          return `<button class="btn btn-dark pd-add" id="addProduct"${pasSortie || epuise ? ' disabled' : ''}>${libelle}</button>`;
        })()}
        <a class="pd-compo" id="compoLink" href="${compoLink}"${(isMaroq || product.available === false) ? ' hidden' : ''}>${isBoucle ? 'Composer ma ceinture avec cette boucle' : isTige ? 'Composer ma ceinture avec cette tige' : 'Composer ma ceinture'}</a>
        ${(function () {
          /* Une pièce pas encore sortie ne « revient » pas en stock : on propose
             d'être prévenue de son ouverture, pas de son retour. */
          const pasSortie = product.bientot === true || !(product.price > 0);
          const montrer = pasSortie || product.available === false;
          const sujet = pasSortie ? 'Ouverture ' + product.name : 'Retour en stock ' + product.name;
          const corps = pasSortie
            ? 'Bonjour, pouvez-vous me prévenir dès que la pièce ' + product.name + ' sera disponible ? Merci.'
            : 'Bonjour, pouvez-vous me prévenir quand la pièce ' + product.name + (product.width ? ' ' + product.width + ' mm' : '') + ' sera de nouveau disponible ? Merci.';
          const texte = pasSortie ? 'Me prévenir à l\'ouverture' : 'Me prévenir du retour de cette pièce';
          return `<a class="pd-notify" id="notifyLink" href="mailto:contact@yolete.fr?subject=${encodeURIComponent(sujet)}&body=${encodeURIComponent(corps)}"${montrer ? '' : ' hidden'}>${texte}</a>`;
        })()}

        <div class="pd-acc">
          ${descHtml ? `<details class="pd-acc-item" open><summary>Description</summary><div class="pd-acc-body pd-desc-shopify">${descHtml}</div></details>`
            : shortD ? `<details class="pd-acc-item" open><summary>Description</summary><div class="pd-acc-body"><p>${shortD}</p></div></details>` : ''}
          ${lignesDetails.length ? `<details class="pd-acc-item"><summary>Détails</summary><div class="pd-acc-body"><ul>
            ${lignesDetails.map(t => `<li>${t}</li>`).join('')}
          </ul></div></details>` : ''}
          <details class="pd-acc-item"><summary>Livraison &amp; retours</summary><div class="pd-acc-body"><p>${echappe(livraison)}</p></div></details>
        </div>
      </div>
    </section>

    <section class="wrap similar">
      <p class="sim-eyebrow">${isBoucle && collLabels[0] ? 'Dans la même collection' : 'Pour continuer'}</p>
      <h2 class="section-title">${isBoucle ? (collLabels[0] || 'Nos suggestions') : 'Vous aimerez aussi'}</h2>
      <div class="product-grid grid-lux" id="similarGrid"></div>
    </section>

    ${isTige ? `
    <div class="modal-overlay" id="sizeOverlay">
      <div class="modal" role="dialog" aria-label="Guide des tailles">
        <button class="modal-close" id="sizeClose" aria-label="Fermer">×</button>
        <h3>${echappe(guideTitre)}</h3>
        <p>${gras(texteFiche('guideIntro', 'La taille correspond à votre **tour de taille** au point de port (en cm).'))}</p>
        <table class="size-table">
          <thead><tr>${guideColonnes.map(t => `<th>${echappe(t)}</th>`).join('')}</tr></thead>
          <tbody>${guideLignes.map(r => `<tr>${r.map(t => `<td>${echappe(t)}</td>`).join('')}</tr>`).join('')}</tbody>
        </table>
        <p class="modal-note">${gras(texteFiche('guideNote', "Chaque cuir se patine et se détend légèrement à l'usage."))}</p>
      </div>
    </div>` : ''}`;

  if (avisServeur) { const sim = root.querySelector('.similar'); if (sim) root.insertBefore(avisServeur, sim); else root.appendChild(avisServeur); }

  const mainImg = document.getElementById('mainImg');
  const thumbs = document.getElementById('thumbs');
  const swatches = document.getElementById('swatches');
  const sizeChips = document.getElementById('sizeChips');
  /* Tige : une taille que Shopify ne vend pas dans le coloris choisi (stock à zéro
     sans vente à la commande) est grisée, au lieu d'échouer à l'ajout au panier. */
  function majTaillesTige() {
    if (!isTige || !sizeChips) return;
    const fiche = (tigePids && PRODUCTS.find(x => x.id === tigePids[selColor])) || product;
    const t = fiche && fiche.tailles;
    sizeChips.querySelectorAll('.pd-chip').forEach(c => {
      const ko = !!(t && t[c.dataset.size] === false);
      c.disabled = ko; c.classList.toggle('is-out', ko);
      c.title = ko ? 'Indisponible dans ce coloris' : '';
      if (ko) c.classList.remove('active');
    });
  }

  /* Vignettes et coloris sont deux listes distinctes : plusieurs coloris peuvent
     partager la même photo, donc leurs index ne correspondent pas. */
  function showPhoto(src) {
    if (!src) return;
    mainImg.src = src;
    if (thumbs) thumbs.querySelectorAll('.thumb').forEach(t => t.classList.toggle('active', t.dataset.img === src));
  }
  /* Stock par finition (Shopify) : une finition épuisée bloque l'achat, les autres restent achetables.
     true = achetable, false = épuisée, null = produit entier épuisé (géré ailleurs, on ne touche à rien).
     La pastille peut nommer la variante exacte (voption, cas de la N27) : on la lit d'abord,
     le rapprochement par mots ne sert qu'à défaut. */
  /* ---------- Maroquinerie : anse choisie, variante et prix ---------- */
  let anseChoisie = ansesShop[0] || '';
  function couleurMaro() {
    const a = swatches && swatches.querySelector('.csw.active');
    return a ? (a.dataset.name || '') : ((product.colors || [])[0] ? (product.colors[0].name || product.colors[0]) : '');
  }
  function varianteMaro(couleur) {
    const vs = product.variants || [];
    if (!vs.length) return null;
    const c = String(couleur || couleurMaro() || '').toUpperCase();
    return vs.find(v => (!c || String(v.option1 || '').toUpperCase() === c || v.option1 === 'Default Title')
                     && (!ansesShop.length || v.option2 === anseChoisie)) || null;
  }
  function majPrixMaro() {
    if (!isMaroq) return;
    const v = varianteMaro(), el = document.getElementById('pdPrice');
    /* Fiche encore en brouillon (repli, sans variantes) : le prix suit le book. */
    const pb = product.prixBook;
    const prix = v ? v.price : (pb && anseChoisie ? (/longue/i.test(anseChoisie) ? pb.long : pb.court) : 0);
    if (el && prix > 0) el.textContent = euro(prix);
  }
  const anseChips = document.getElementById('anseChips');
  if (anseChips) anseChips.addEventListener('click', e => {
    const b = e.target.closest('.pd-chip'); if (!b) return;
    anseChips.querySelectorAll('.pd-chip').forEach(x => x.classList.toggle('active', x === b));
    anseChoisie = b.dataset.anse || '';
    majPrixMaro();
  });

  const normOpt = s => String(s || '').toUpperCase().normalize('NFD').replace(/[̀-ͯ]/g, '')
    .replace(/\s*\/\s*\d+\s*MM\s*$/, '').replace(/\s+/g, ' ').trim();
  /* Variante Shopify d'une finition de boucle : son stock et son prix font foi. */
  function varianteBoucle(label, voption) {
    if (!window.__yoleteCart || !label) return null;
    const p = voption && __yoleteCart.BYH && __yoleteCart.BYH[product.id];
    let v = null;
    if (p) v = p.variants.find(x => normOpt(x.option1) === normOpt(voption) || normOpt(x.title) === normOpt(voption)) || null;
    return v || __yoleteCart.boucleVariant(product.id, label);
  }
  /* Deux finitions peuvent avoir deux prix dans Shopify : la fiche montre celui de
     la finition choisie, pas le plus bas (21/10/2026). */
  function majPrixBoucle(label, voption) {
    if (!isBoucle || !(product.price > 0)) return;
    try {
      const v = varianteBoucle(label, voption), el = document.getElementById('pdPrice');
      if (v && v.price > 0 && el) el.textContent = euro(v.price);
    } catch (e) {}
  }
  function finitionOk(label, sid, voption) {
    /* Pièce pas encore ouverte à la vente : le bouton reste « Bientôt disponible »,
       quel que soit le stock Shopify (verrou suggéré par yolete-f7, 25 sept 2026). */
    if (product.bientot === true) return null;
    try {
      if (isBoucle && window.__yoleteCart && label) {
        if (product.available === false) return null;
        const v = varianteBoucle(label, voption);
        return !(v && v.available === false);
      }
      if (isTige && typeof yoleteTigeStock === 'function') { const st = yoleteTigeStock(sid || product.id); return !(st !== null && st <= 0); }
      if (product.available === false) return null;
    } catch (e) {}
    return true;
  }
  function syncStock(label, sid, voption) {
    const btn = document.getElementById('addProduct'), notif = document.getElementById('notifyLink'), compo = document.getElementById('compoLink');
    if (!btn) return;
    const ok = finitionOk(label, sid, voption);
    if (ok === null) return;
    btn.disabled = !ok; btn.textContent = ok ? libelleAjout : (isTige ? 'Épuisée dans ce coloris' : 'Épuisé dans cette finition');
    if (notif) notif.hidden = ok;
    if (compo) compo.hidden = !ok;
  }
  function selectColor(i) {
    if (!ways || !ways[i]) return;
    sel = i; selColor = i;
    showPhoto(ways[i].photo || ways[i].img);
    if (swatches) swatches.querySelectorAll('.csw').forEach((s, k) => s.classList.toggle('active', k === i));
    const nm = document.getElementById('colorName');
    if (nm) nm.textContent = ways[i].label || `Coloris ${i + 1}`;
    syncStock(ways[i].label, ways[i].sid, ways[i].voption);
    majPrixBoucle(ways[i].label, ways[i].voption);
    if (isTige && ways[i].price > 0) { const pe = document.getElementById('pdPrice'); if (pe) pe.textContent = euro(ways[i].price); }
    majTaillesTige();
    majLienComposeur();
  }
  function selectIdx(i) { selectColor(i); }   /* compat */

  /* Cliquer une vignette doit aussi déplacer la pastille de coloris. Sinon on
     regardait une finition et on ajoutait l'autre au panier, celle restée
     sélectionnée dans le sélecteur. */
  if (thumbs) thumbs.addEventListener('click', e => {
    const btn = e.target.closest('.thumb'); if (!btn) return;
    const src = btn.dataset.img;
    if (ways && ways.length) {
      const courant = ways[selColor] && (ways[selColor].photo || ways[selColor].img);
      if (courant !== src) {
        const i = ways.findIndex(w => (w.photo || w.img) === src);
        if (i >= 0) { selectColor(i); return; }
      }
    } else if (swatches) {
      /* coloris hérités : la pastille porte sa photo dans data-img */
      const cibles = [...swatches.querySelectorAll('.csw')].filter(c => c.dataset.img === src);
      const cible = cibles.length === 1 ? cibles[0] : null;
      if (cible && !cible.classList.contains('active')) {
        swatches.querySelectorAll('.csw').forEach(c => c.classList.toggle('active', c === cible));
        const nm = document.getElementById('colorName');
        if (nm && cible.dataset.name) nm.textContent = cible.dataset.name;
      }
    }
    showPhoto(src);
  });

  if (swatches) swatches.addEventListener('click', e => {
    const btn = e.target.closest('.csw'); if (!btn) return;
    if (ways && btn.dataset.idx !== undefined) selectColor(+btn.dataset.idx);
    else {
      swatches.querySelectorAll('.csw').forEach(s => s.classList.toggle('active', s === btn));
      const nm = document.getElementById('colorName'); if (nm) nm.textContent = btn.dataset.name;
      if (btn.dataset.img) showPhoto(btn.dataset.img);   /* la vignette active suit la photo */
      majPrixMaro();
    }
  });

  /* À l'ouverture, la fiche montrait toujours la première finition, même épuisée, avec un
     bouton « Ajouter au panier » actif : le clic finissait en erreur de stock (N214, Topaze
     passée à 0 le 23/09/2026). Une boucle s'ouvre donc sur sa première finition achetable,
     et le bouton suit le vrai stock dès le chargement. Une tige garde le coloris de son
     adresse, seul son bouton est mis à jour. */
  if (ways && ways.length) {
    let depart = sel;
    if (isBoucle && finitionOk(ways[sel].label, ways[sel].sid, ways[sel].voption) === false) {
      const i = ways.findIndex(w => finitionOk(w.label, w.sid, w.voption) === true);
      if (i >= 0) depart = i;
    }
    if (depart !== sel) selectColor(depart);
    else { syncStock(ways[sel].label, ways[sel].sid, ways[sel].voption); majPrixBoucle(ways[sel].label, ways[sel].voption); }
  }

  /* Taille (tige) : sélection */
  majTaillesTige();
  if (sizeChips) sizeChips.addEventListener('click', e => {
    const btn = e.target.closest('.pd-chip'); if (!btn) return;
    sizeChips.querySelectorAll('.pd-chip').forEach(c => c.classList.toggle('active', c === btn));
    majLienComposeur();
  });

  /* Ajout au panier (coloris + taille) */
  const addBtn = document.getElementById('addProduct');
  if (addBtn) addBtn.addEventListener('click', () => {
    let label = '';
    if (ways && ways[selColor]) label = ways[selColor].label || `Coloris ${selColor + 1}`;
    else if (!ways && (product.colors || [])[0]) {
      const active = swatches && swatches.querySelector('.csw.active');
      label = active ? (active.dataset.name || '') : product.colors[0].name;
    }
    if (isTige) {
      const s = sizeChips && sizeChips.querySelector('.pd-chip.active');
      if (!s) { toast('Choisissez une taille'); sizeChips.classList.remove('pd-nudge'); void sizeChips.offsetWidth; sizeChips.classList.add('pd-nudge'); return; }
      label = (label ? label + ' · ' : '') + 'T' + s.dataset.size;
    }
    /* La pastille peut nommer la variante Shopify exacte (voption), seul repère
       sûr quand une option mélange deux choses, « SILVER - PIERRES BLACK » sur
       la N27 : l'étiquette française seule y désignait la mauvaise finition. */
    let voption = (ways && ways[selColor] && ways[selColor].voption) || '';
    /* Sac : on nomme la variante Shopify exacte (coloris et anse), sinon le
       panier prenait la première variante de la fiche (corrigé le 25 sept 2026). */
    if (isMaroq) { const vm = varianteMaro(label); if (vm) voption = vm.title; }
    const variant = { label: label, voption: voption,
                      img: (ways && ways[selColor] ? (ways[selColor].photo || product.img) : (imgs[sel] || product.img)) };
    const addId = (tigePids && tigePids[selColor]) ? tigePids[selColor] : product.id;
    addToCart(addId, variant);
  });

  /* Guide des tailles */
  const sizeBtn = document.getElementById('sizeGuideBtn');
  const sizeOverlay = document.getElementById('sizeOverlay');
  if (sizeBtn && sizeOverlay) {
    sizeBtn.addEventListener('click', () => sizeOverlay.classList.add('open'));
    document.getElementById('sizeClose').addEventListener('click', () => sizeOverlay.classList.remove('open'));
    sizeOverlay.addEventListener('click', e => { if (e.target === sizeOverlay) sizeOverlay.classList.remove('open'); });
    document.addEventListener('keydown', e => { if (e.key === 'Escape') sizeOverlay.classList.remove('open'); });
  }

  /* Produits similaires — maquette A « rangée de planches » :
     mêmes cartes que la boutique (grid-lux), titrées par la collection de la
     pièce. Choix : même collection ET même largeur d'abord, puis même largeur,
     puis le reste du type. */
  /* Règles : uniquement ce que la page Boucles propose (dossier du site), même
     largeur, en stock, jamais le même modèle sous une autre fiche. Même collection
     d'abord, puis le reste de la largeur. Moins de deux pièces : la section disparaît. */
  const coll0 = (product.collections || [])[0];
  const okF = p => (typeof inFolderBoucle !== 'function') || inFolderBoucle(p);
  const base = p => (typeof boucleBase === 'function') ? (boucleBase(p) || p.id) : p.id;
  /* Suggestions. Pour la maroquinerie, sacs et anses forment une seule famille :
     une anse se propose sous un sac, et inversement. Et comme la collection
     n'est pas encore ouverte à la vente, on ne peut pas exiger `available`,
     sinon la section serait toujours vide. */
  const pool = isMaroq
    ? PRODUCTS.filter(p => p.id !== product.id && (p.type === 'sac' || p.type === 'anse'))
    : PRODUCTS.filter(p => p.id !== product.id && p.type === product.type && okF(p)
      && (!product.width || p.width === product.width)
      && (p.available !== false)
      && (!isBoucle || base(p) !== base(product)));
  const score = p => (coll0 && (p.collections || []).includes(coll0)) ? 0 : 1;
  let simi = pool.slice().sort((a, b) => score(a) - score(b));
  if (isBoucle && typeof dedupeBoucles === 'function') simi = dedupeBoucles(simi);
  const simSection = document.querySelector('.similar');
  if (simi.length < 2) { if (simSection) simSection.hidden = true; }
  else document.getElementById('similarGrid').innerHTML = simi.slice(0, 4).map(cardHTML).join('');

  observeReveals();
}

/* « Me prévenir » : le lien est un courriel prérempli, qui ne fait rien sur un
   téléphone sans messagerie ou dans un navigateur intégré (signalé par Nathan le
   24 sept 2026). Quand la fenêtre d'inscription est disponible, on l'ouvre à la
   place : l'adresse part alors dans Clients, avec une étiquette par pièce. Le
   lien reste en repli si la fenêtre est désactivée dans le thème. */
document.addEventListener('click', function (e) {
  var a = e.target.closest && e.target.closest('#notifyLink');
  if (!a || !(window.yoleteLettre && window.yoleteLettre.ouvrir)) return;
  e.preventDefault();
  var p = (typeof product !== 'undefined' && product) ? product : null;
  var pasSortie = /subject=Ouverture/.test(a.getAttribute('href') || '');   /* le libellé est traduit, pas le sujet du courriel */
  window.yoleteLettre.ouvrir(pasSortie
    ? { tag: 'sortie-' + ((p && p.id) || 'maroquinerie') }
    : {
        titre: 'Prévenez-moi du retour',
        accent: (p && p.name) || '',
        texte: 'Laissez votre adresse, nous vous écrivons dès que la pièce revient en stock.',
        bouton: 'Prévenez-moi',
        tag: 'retour-' + ((p && p.id) || 'piece'),
      });
});
